import { createApp, ref } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import { dayjs } from 'element-plus';
import './views/index.css';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
// import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'dayjs/locale/zh-cn';

dayjs.en.weekStart = 1;

// 统一导入el-icon图标
import 'element-plus/dist/index.css';

import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import directives from './directive';

import ECharts from 'vue-echarts';
import 'echarts';

import '@/utils/batch';

import VxeUITable from 'vxe-table';
import 'vxe-table/lib/style.css';

// import VXETable from 'vxe-table';
// import 'vxe-table/lib/style.css';

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import '@/utils/browerPatch';

import VueFullscreen from 'vue-fullscreen';

import VuePreview from 'vue-preview';

import 'bpmn-js/dist/assets/diagram-js.css'; // 左边工具栏以及编辑节点的样式
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';

// import formCreate from '@form-create/element-ui';
// import FcDesigner from '@form-create/designer';

import modelerStore from '@/components/Process/common/global';

import htmlToPdf from './utils/htmlToPdf';

// 全局方法挂载
window.globalConfig = {};
window.globalConfig.modelerStore = modelerStore;

// 全局组件挂载

import formCreate from '@form-create/element-ui';

import FcDesigner from '@form-create/designer';

// import 'moment-holidays';

import 'moment-business-days';

import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts/highcharts';
Highcharts.setOptions({
    lang: {
        locale: 'zh-CN'
    }
});

import venn from 'highcharts/modules/venn';
// venn(Highcharts);

function useTable(app) {
    app.use(VxeUITable);
}
window.addEventListener('touchmove', () => {}, { passive: false });
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

app.use(FcDesigner);
app.use(formCreate);
// app.use(FcDesigner);
// app.use(formCreate);
app.use(store)
    .use(router)
    .use(directives)
    .use(useTable)
    .use(VuePreview)
    .use(VCalendar, {})
    .use(ElementPlus)
    .use(HighchartsVue, { Highcharts })
    .mount('#app');
